// Changes made by KHALID STARTS

import axios from "axios";

// const API_BASE_URL = `https://barbackend.barassociationdehradun.com/api`;
// const API_BASE_URL = `http://172.10.10.117:85/api`;
// const API_BASE_URL = `http://172.10.10.150:93/api`;

// const API_BASE_URL = `https://localhost:7237/api`;

const API_BASE_URL =
  process.env.NODE_ENV === "production"
    ? `https://barbackend.barassociationdehradun.com/api`
    : `https://localhost:7237/api`;
const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "X-FrontEnd-Token": "BarAssociation#SarahSarmar@123",
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

export default axiosInstance;

// Changes made by KHALID ENDS
